import { useContext } from "react"
import { ScenarioContext } from "../providers/ScenarioProvider";

const useScenario = () => {
    const context = useContext(ScenarioContext);
    if (context === undefined) {
        throw new Error('useScenario must be used within a ScenarioProvider');
    }
    const { scenario, setScenario, loading, simulation_time, set_simulation_time, telemetry_time, set_telemetry_time } = context;
    return {
        loading,
        scenario,
        setScenario,
        telemetry_time,
        simulation_time,
        set_telemetry_time,
        set_simulation_time,
    };
}

export default useScenario